(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("hEmployeeSatisfactionService", HEmployeeSatisfactionService);

    HEmployeeSatisfactionService.$inject = ['hUser', '$q', '$filter', 'TeamScheduleService', 'userPermissions', 'brandServices'];

    function HEmployeeSatisfactionService(hUser, $q, $filter, TeamScheduleService, userPermissions, brandServices) {
        var self = this;
        var cache = {};
        var detailedCache = {};
        var cachedPeriod;
        var EMPLOYEE_SATISFACTION_TREND_STATUSES = {
            IMPROVING: {
                id: "IMPROVING",
                value: "IMPROVING",
                label: $filter("translate")("Improving"),
                icon: 'trend-satisfaction-icon improving-icon',
            },
            DECLINING: {
                id: "DECLINING",
                value: "DECLINING",
                label: $filter("translate")("Declining"),
                icon: 'trend-satisfaction-icon declining-icon',
            },
            NEUTRAL: {
                id: "NEUTRAL",
                value: "NEUTRAL",
                label: $filter("translate")("Neutral"),
                icon: 'trend-satisfaction-icon neutral-icon',
            },
            VERY_SATISFIED: {
                id: "VERY_SATISFIED",
                value: "VERY_SATISFIED",
                label: $filter("translate")("Very Satisfied"),
                icon: 'satisfaction-icon very-satisfied-icon',
                color: '#72DFA2'
            },
            SOMEWHAT_SATISFIED: {
                id: "SOMEWHAT_SATISFIED",
                value: "SOMEWHAT_SATISFIED",
                label: $filter("translate")("Somewhat Satisfied"),
                icon: 'satisfaction-icon somewhat-satisfied-icon',
                color: '#FDE465'
            },
            SOMEWHAT_DISSATISFIED: {
                id: "SOMEWHAT_DISSATISFIED",
                value: "SOMEWHAT_DISSATISFIED",
                label: $filter("translate")("Somewhat Dissatisfied"),
                icon: 'satisfaction-icon somewhat-dissatisfied-icon',
                color: '#F59F43'
            },
            VERY_DISSATISFIED: {
                id: "VERY_DISSATISFIED",
                value: "VERY_DISSATISFIED",
                label: $filter("translate")("Very Dissatisfied"),
                icon: 'satisfaction-icon dissatisfied-icon',
                color: '#E54C50'
            }
        };
        var EMPLOYEE_SATISFACTION_PERIODS = [
            {
                name: $filter('translate')('Last 4 Weeks'),
                value: 'LAST_MONTH'
            },
            {
                name: $filter('translate')('Last 3 Months'),
                value: 'LAST_3_MONTHS',
            },
            {
                name: $filter('translate')('Last 6 Months'),
                value: 'LAST_6_MONTHS'
            },
            {
                name: $filter('translate')('Last 12 Months'),
                value: 'LAST_12_MONTHS'
            },
            {
                name: $filter('translate')('All Periods'),
                value: 'ALL_PERIODS'
            }
        ];

        self.loadTeamSatisfactionModel = function (brandId) {
            var groupId = hUser.getEntryMode().brand_id;

            brandId = brandId || groupId;

            var defer = $q.defer();

            if (cache[groupId + '_' + brandId]) {
                defer.resolve(angular.copy(cache[groupId + '_' + brandId]));
            } else {
                SatisfactionAPI.getTeamSatisfaction(groupId, brandId).then(function (data) {
                    var employeesMap = {};

                    data.employees.forEach(function (employee) {
                        employeesMap[employee.user_id + '_'  + employee.group_id] = employee;
                    });

                    cache[groupId + '_' + brandId] = angular.copy(employeesMap);
                    defer.resolve(employeesMap);
                });
            }

            return defer.promise;
        };

        self.loadUsersDetailsSatisfactionModel = function (userId, brandId, period) {
            var groupId = hUser.getEntryMode().brand_id;

            brandId = brandId || hUser.getUserContext().brand_id;

            var defer = $q.defer();

            if (period !== cachedPeriod) {
                detailedCache = {};
            }

            if (detailedCache[userId]) {
                defer.resolve(angular.copy(detailedCache[userId]));
            } else {
                cachedPeriod = period;

                SatisfactionAPI.getEmployeeSatisfaction(groupId, groupId, period, userId).then(function (data) {
                    var employeesMap = {};

                    data.employees.forEach(function (employee) {
                        employeesMap[employee.user_id] = employeesMap[employee.user_id] || [];
                        employeesMap[employee.user_id].push(employee);
                    });
                    detailedCache[userId] = angular.copy(employeesMap);
                    defer.resolve(employeesMap);
                });
            }

            return defer.promise;
        };

        self.getUserSatisfactionModel = function (userId, brandId, period) {
            var defer = $q.defer();

            self.loadUsersDetailsSatisfactionModel(userId, brandId, period).then(function (employees) {
                defer.resolve(employees[userId]);
            });

            return defer.promise;
        };

        self.isEmployeeSatisfactionEnabled = function (brandId) {
            var defer = $q.defer();
            var promises = {};

            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);
            promises['isSatisfactionServiceEnabled'] = brandServices.check(
                brandServices.SERVICES.EMPLOYEE_SATISFACTION_MODEL,
                brandId
            );

            $q.all(promises).then(function (res) {
                var policyParser = res['policyParser'];
                var isSatisfactionServiceEnabled = res['isSatisfactionServiceEnabled'];

                defer.resolve(
                    isSatisfactionServiceEnabled &&
                    policyParser.has(userPermissions.PERMISSIONS.MANAGE_VIEW_SATISFACTION)
                );
            }, function (err) {
                defer.reject(err);
            });

            return defer.promise;
        };

        self.getEmployeeSatisfactionTrendStatusesMap = function () {
            return EMPLOYEE_SATISFACTION_TREND_STATUSES;
        };

        self.getEmployeeSatisfactionTrendStatus = function (code) {
            return EMPLOYEE_SATISFACTION_TREND_STATUSES[code];
        };

        self.getEmployeeSatisfactionStatuses = function () {
            var statuses = ['VERY_SATISFIED', 'SOMEWHAT_SATISFIED', 'SOMEWHAT_DISSATISFIED', 'VERY_DISSATISFIED'];
            var employeeSatisfactionStatuses = [];

            for (var i = 0; i < statuses.length; i++) {
                employeeSatisfactionStatuses.push(EMPLOYEE_SATISFACTION_TREND_STATUSES[statuses[i]]);
            }

            return employeeSatisfactionStatuses;
        };

        self.getEmployeeSatisfactionTrendStatuses = function () {
            var statuses = ['IMPROVING', 'DECLINING', 'NEUTRAL'];
            var employeeSatisfactionTrendStatuses = [];

            for (var i = 0; i < statuses.length; i++) {
                employeeSatisfactionTrendStatuses.push(EMPLOYEE_SATISFACTION_TREND_STATUSES[statuses[i]]);
            }

            return employeeSatisfactionTrendStatuses;
        };

        self.getEmployeeSatisfactionPeriods = function () {
            return EMPLOYEE_SATISFACTION_PERIODS;
        };
    }
})();